<template>
  <div class="app-container d-flex flex-column">
    <LoginNavigation>
      <nuxt-link
        class="d-flex align-center"
        :to="{ path: '/', query: { ...$route.query } }"
      >
        <svg-icon
          class="primary--text"
          name="tap2link-logo"
          width="54"
          height="25"
        />
      </nuxt-link>
      <div class="d-flex align-center">
        <p class="text-body-2 mr-3">{{ $t('login.noAccount') }}</p>
        <Button
          height="44"
          class="text-h1 button--rounded button--secondary"
          @click="routerPushWithQuery('/register')"
        >
          {{ $t('login.registerNow') }}
        </Button>
      </div>
    </LoginNavigation>
    <main class="token d-flex flex-column container">
      <div v-show="custom" class="token__header">
        <div class="d-flex flex-column justify-center">
          <h1 class="text-h1 primary-dark--text">
            {{ $t('login.resetPassword') }}
          </h1>
          <p class="text-body-2 dark-grey--text mb-2">
            {{ $t('login.choosePassword') }}
          </p>
        </div>
        <v-img
          :src="customLogo"
          class="ml-auto rounded-lg"
          width="68"
          max-height="68"
          :alt="`${customCompanyName}logo`"
        />
      </div>
      <h1 v-show="!custom" class="text-h1 primary-dark--text">
        {{ $t('login.resetPassword') }}
      </h1>
      <p v-show="!custom" class="text-body-2 dark-grey--text mb-2">
        {{ $t('login.choosePassword') }}
      </p>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <v-form
          class="token__form d-flex flex-column"
          @submit.prevent="handleSubmit(handlePasswordChange)"
        >
          <CompactInput
            v-model="password.value"
            :label="password.label"
            :placeholder="
              $t('login.insertPlaceholder', { inputLabel: password.label })
            "
            name="password"
            type="password"
            rules="required|passwordRules"
          />
          <CompactInput
            v-model="passwordRepeat.value"
            :label="passwordRepeat.label"
            :placeholder="
              $t('login.insertPlaceholder', {
                inputLabel: passwordRepeat.label,
              })
            "
            type="password"
            rules="required|confirmed:password"
            @focus="focusOnInput"
          />
          <Button
            width="100%"
            height="64"
            class="token__btn button--rounded button--primary"
            :class="!isMobile && 'mt-auto'"
            type="submit"
          >
            {{ $t('login.savePassword') }}
          </Button>
        </v-form>
      </ValidationObserver>
    </main>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { mapActions } from 'vuex';

import customTheme from '~/mixins/customTheme';

export default {
  name: 'token',
  components: {
    LoginNavigation: () => import('~/components/shared/AppNavigation.vue'),
    Button: () => import('~/components/shared/Button.vue'),
    CompactInput: () => import('~/components/shared/Compact.vue'),
    ValidationObserver,
  },
  mixins: [customTheme],
  layout: 'app',
  data() {
    return {
      password: {
        value: '',
        label: this.$t('login.yourNewPassword'),
      },
      passwordRepeat: {
        value: '',
        label: this.$t('login.repeatNewPassword'),
      },
      isMobile: false,
    };
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    focusOnInput() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.isMobile = true;
      }
    },
    handlePasswordChange() {
      this.resetPassword({
        token: this.$route.params.token,
        password: this.password.value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: 100vh;
  padding-bottom: 5rem !important;
}

.token {
  margin-top: 8rem;
  gap: 1rem;
  &__btn {
    &::v-deep {
      .v-btn__content {
        line-height: 1.55;
      }
    }
  }
  &__form {
    height: 100%;
    gap: 1rem;
  }
  &__message {
    font-size: 0.75rem;
    line-height: 1;
    letter-spacing: 0.1em;
  }
}
</style>
